<rt-dropdown-header>
  <rt-icon-button
    prefix
    variant="plain"
    iconName="arrow-back"
    shape="square"
    size="small"
    (click)="$event.preventDefault(); backButtonClick.emit($event)"
  />
  <span>{{ 'app.header.appearance.admin_dropdown_header' | translate }}</span>
</rt-dropdown-header>
@for (item of themeItems; track trackByValue($index, item)) {
  <rt-dropdown-item [isSelected]="selectedTheme === item" (click)="onThemeItemCLick($any(item))">
    <rt-icon prefix [name]="themeIconRecord[item]" [size]="'medium'" />
    {{ themeNameRecord[item] | translate }}
  </rt-dropdown-item>
}
